import LikeButton from './LikeButton';
import LikeButtonContainer from './LikeButton.container';
export default LikeButtonContainer(LikeButton);
